<template>
  <v-dialog
    v-model="dialog"
    overlay
    persistent
    max-width="400px"
    transition="dialog-transition"
  >
    <template #activator="{ attrs,on }">
      <v-btn
        class="d-print-none"
        icon
        v-on="on"
        v-bind="attrs"
        color="warning darken-3"
      >
        <v-icon right>fas fa-user-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="error headline white--text"
        >Edite Date Form
        <v-spacer></v-spacer>
        <v-btn dark icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-3">
        <v-form v-model="valid" ref="withDrowform">
          <BaseDate
            v-model="PayDate"
            outlined
            :rules="v => !!v || 'Date is required'"
          >
          </BaseDate>

          <v-text-field
            :readonly="Disable.Details"
            name="InfoFildName"
            label="Details"
            id="InfoFildid"
            outlined
            v-model.trim="Details"
            :rules="[v => !!v || 'Provide Infomation']"
          ></v-text-field>
        </v-form>
        <p v-if="ErrMsg" v-html="ErrMsg" class="text-center error--text"></p>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          width="200px"
          :loading="loading"
          @click="OnSavePayment"
          :disabled="!valid"
          color="success"
          >Save Edite</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    // keys: {
    //   type: Object,
    //   default: () => ({ Details: "Details", date: "date", Ref: "Ref" }),
    // },
    DetailsKey: {
      type: String,
      default: () => "Details",
    },
    RefKey: {
      type: String,
      default: () => "Ref",
    },
    dateKey: {
      type: String,
      default: () => "date",
    },
    Disable: {
      type: Object,
      default: () => ({ Details: false }),
    },
    Info: { type: Object, required: true },
    BaseURL: { type: String, required: true },
    FinishedWithdrow: {
      type: Function,
      default: () => null,
    },
  },

  data() {
    return {
      ErrMsg: "",
      loading: false,
      dialog: false,
      valid: false,
      PayDate: "",
      //   Amount: 0,
      Details: "",
    };
  },
  watch: {
    dialog(v) {
      if (v) {
        // console.log(this.Info);
        this.$nextTick(() => {
          this.PayDate = this.Info[this.dateKey];
          this.Details = this.Info[this.DetailsKey];
          // this.Amount = this.DueAmount;
          //   this.Amount = 0;
        });
      }
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.ErrMsg = "";
      this.PayDate = "";
      this.Details = "";
      this.$refs.withDrowform.resetValidation();
    },

    OnSavePayment() {
      this.ErrMsg = "";
      if (this.$refs.withDrowform.validate()) {
        let data = {
          [this.DetailsKey]: this.Details,
          [this.dateKey]: this.PayDate,
          [this.RefKey]: this.Info[this.RefKey],
        };
        this.loading = true;
        this.$store
          .dispatch("UPDATE_ONLY", { url: this.BaseURL + "/Editedate", data })
          .then(() => {
            // console.log(val);
            this.loading = false;
            this.FinishedWithdrow(this.Details);
            this.close();
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.ErrMsg = error && error.response && error.response.data;
          });
      }
    },
  },
};
</script>
